var map = {
	"./en-QM.json": [
		2108,
		108
	],
	"./en-US.json": [
		9594,
		594
	],
	"./en.json": [
		790,
		790
	],
	"./es.json": [
		8563,
		563
	],
	"./pt-BR.json": [
		6837,
		837
	],
	"./pt.json": [
		9898,
		898
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;